<button
  class="btn btn-light user-profile p-0"
  [class.active]="isMenuOpen()"
  type="button"
  jest-id="profileMenu"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="toggleMenu()"
>
  @if(userProfilePhotoUrl() != null) {
    <img [src]="userProfilePhotoUrl()" class="round-image" style="width: 44px; height: 44px;" alt="user-profile-picture"/>
  }
  @else {
    <img [src]="userIcon()" alt="user-profile" style="width: 44px; height: 44px;"/>
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isMenuOpen()"
  [cdkConnectedOverlayOffsetY]="10"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  (overlayOutsideClick)="toggleMenu(false)"
>
  <ul class="dropdown-list border bg-light rounded-2 small list-unstyled mw-100">
    <li class="option-item flex-column align-items-start">
      <div class="text-body-tertiary">Signed in as:</div>
      <div class="text-body-primary fw-normal">{{ userDisplayName() }}</div>
      <div class="text-body-tertiary small">Role:</div>
      <div class="text-body-primary fw-normal">{{ getUserRole() }}</div>
      <div class="text-body-tertiary small">Site:</div>
      <div class="text-body-primary fw-normal">{{ getUserSite() }}</div>
      @if (siteGroupName()) {
        <div class="text-body-tertiary small">Group:</div>
        <div class="text-body-primary fw-normal" jest-id="profileGroup">{{ siteGroupName() }}</div>
      }
    </li>

    <li><hr class="m-0 border-top" /></li>

    <li class="option-item" routerLink="settings/site" routerLinkActive="active" role="link">
      <svg-icon class="mh-svg-body-primary" [src]="switchIcon()" [applyClass]="true" />
      <span class="text-truncate">Switch Location</span>
    </li>

    <li class="option-item" role="button" jest-id="userGuideBtn" (click)="openUserGuide($event)">
      <svg-icon class="mh-svg-body-primary" [src]="guideIcon()" [applyClass]="true" />
      <span class="text-truncate">User guide</span>
    </li>

    <li><hr class="m-0 border-top" /></li>

    <li class="option-item" role="button" (click)="logout($event)" jest-id="logoutBtn">
      <svg-icon class="mh-svg-body-primary" [src]="logoutIcon()" [applyClass]="true" />
      <span class="text-truncate">Sign out</span>
    </li>
  </ul>
</ng-template>
